import { Form, Formik } from 'formik'
import React from 'react'
import { required } from '../utils/validators'
import Input from './common/Input'
import Button from './common/Button'

export default function TaskBoardForm({ onSubmit, onCancel, loading, initialValues = {} }) {
    return (
        <Formik initialValues={{ name: '', ...initialValues }} onSubmit={onSubmit}>
            <Form>
                <Input
                    name="name"
                    label="Заголовок спринта"
                    placeholder="Например 'Спринт 4 (10 ноября)'"
                    disabled={loading}
                    validate={required} />

                <Button
                    loading={loading}
                    text="Сохранить"
                    type="submit"
                    icon="ion-md-checkmark"
                    disabled={loading}
                    className="is-success" /> &nbsp;

                <Button
                    onClick={onCancel}
                    icon="ion-md-close"
                    text="Отмена"
                    disabled={loading}
                    className="is-danger" />
            </Form>
        </Formik>
    )
}
